import { TimeLogFragment as TimeLog } from "@typing/Generated";

export const sortByDate = (timeLogs: TimeLog[]) =>
  [...timeLogs].sort((a, b) => {
    if (!a.date || !b.date) {
      return 0;
    }

    if (a.date.getTime() === b.date.getTime()) {
      return a.createdAt > b.createdAt ? -1 : 1;
    }

    return a.date > b.date ? -1 : 1;
  });
